import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import MotivosServices from "./motivos_services";

export const getMotivos = filters => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_MOTIVOS,
      payload: true,
    });
    const resp = await MotivosServices.getMotivos(filters);
    // console.clear();
    // console.log('RESPONSE => ', resp.data);
    dispatch({
      type: actions.GET_MOTIVOS,
      payload: resp.data, // agregar .data
    });
    dispatch({
      type: actions.MOTIVOS_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.MOTIVOS_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_MOTIVOS,
      payload: false,
    });
  }
}

export const deleteMotivos = (id, index) => async (dispatch, getState) => {
  try {
    debugger;
    dispatch({
      type: actions.LOADER_MOTIVOS,
      payload: true,
    });
    await MotivosServices.deleteMotivo(id);
    const { data, count } = getState().motivos.motivos;
    let _data = data.slice();
    _data.splice(index, 1);
    dispatch({
      type: actions.GET_MOTIVOS,
      payload: {
        data: _data,
        count: count - 1
      },
    });
    dispatch({
      type: actions.MOTIVOS_FALLA,
      payload: '',
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.MOTIVOS_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_MOTIVOS,
      payload: false,
    });
  }
}

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const editMotivos = (req, index, setShowModal) => async (dispatch, getState) => {
  try {
    debugger;
    dispatch({
      type: actions.LOADER_MOTIVOS,
      payload: true,
    });
    const resp = await MotivosServices.editMotivos(req.id, req);
    const { data, count } = getState().motivos.motivos;
    let _data = data.slice();
    _data[index] = resp.data;
    dispatch({
      type: actions.GET_MOTIVOS,
      payload: {
        data: _data,
        count: count,
      },
    });
    dispatch({
      type: actions.FORM_MOTIVOS_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.MOTIVOS_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_MOTIVOS,
      payload: false,
    });
  }
}

export const saveMotivo = (req, setShowModal) => async (dispatch, getState) => {
  try {
    debugger;
    dispatch({
      type: actions.SAVE_LOADER_MOTIVOS,
      payload: true,
    });
    const resp = await MotivosServices.saveMotivo(req);
    const { data, count } = getState().motivos.motivos;
    dispatch({
      type: actions.GET_MOTIVOS,
      payload: {
        count: count + 1,
        data: [...data, resp.data]
      },
    });
    dispatch({
      type: actions.FORM_MOTIVOS_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_MOTIVOS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_MOTIVOS,
      payload: false,
    });
  }
};
